/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from '@tanstack/react-query'

import type {
    HTTPValidationErrorDTO,
    PostRequestApproveTosParams,
    PostRequestSetTosReviewedParams,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Approve the provided ToS version

 * @summary Post Approve Tos
 */
export const postRequestApproveTos = (
    params: PostRequestApproveTosParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        { url: `/approve_tos`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestApproveTosMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestApproveTos>>,
        TError,
        { params: PostRequestApproveTosParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestApproveTos>>,
    TError,
    { params: PostRequestApproveTosParams },
    TContext
> => {
    const mutationKey = ['postRequestApproveTos']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestApproveTos>>,
        { params: PostRequestApproveTosParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestApproveTos(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestApproveTosMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestApproveTos>>
>

export type PostRequestApproveTosMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Approve Tos
 */
export const usePostRequestApproveTos = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestApproveTos>>,
            TError,
            { params: PostRequestApproveTosParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestApproveTos>>,
    TError,
    { params: PostRequestApproveTosParams },
    TContext
> => {
    const mutationOptions = getPostRequestApproveTosMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This endpoint is used to signal that ToS have been reviewed by the user

 * @summary Set Tos Reviewed
 */
export const postRequestSetTosReviewed = (
    params: PostRequestSetTosReviewedParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        { url: `/set_tos_reviewed`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestSetTosReviewedMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestSetTosReviewed>>,
        TError,
        { params: PostRequestSetTosReviewedParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestSetTosReviewed>>,
    TError,
    { params: PostRequestSetTosReviewedParams },
    TContext
> => {
    const mutationKey = ['postRequestSetTosReviewed']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestSetTosReviewed>>,
        { params: PostRequestSetTosReviewedParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestSetTosReviewed(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestSetTosReviewedMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestSetTosReviewed>>
>

export type PostRequestSetTosReviewedMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Set Tos Reviewed
 */
export const usePostRequestSetTosReviewed = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestSetTosReviewed>>,
            TError,
            { params: PostRequestSetTosReviewedParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestSetTosReviewed>>,
    TError,
    { params: PostRequestSetTosReviewedParams },
    TContext
> => {
    const mutationOptions = getPostRequestSetTosReviewedMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
